import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import Navigation from '../components/Navigation';
import OrganisationMediaLibrariesTable from '../components/OrganisationMediaLibrariesTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';
import DismissableAlert from '../components/DismissableAlert';
import qs from 'qs';

import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    FormGroup,
    InputGroup
} from 'react-bootstrap';

import { translate } from 'react-i18next';

import './OrganisationMediaLibraries.css';

class OrganisationMediaLibraries extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            lockedGlobals: false,
            userIsAuthorized: props.userIsAuthorized,
            medialibraries: [],
            page: props.page,
            pageCount: 0,
            limit: 40,
            search: props.search,
            selected: props.selected - 1,
            error: {
                hidden: true,
                title: '',
                message: '',
                style: 'danger'
            },
            selectedMediaLibraries: new Set(),
            selectedMediaLibrariesData: new Map(),
            selectAllMode: false,
            totalMediaLibraries: 0,
            excludedMediaLibraries: new Set(),
            excludedMediaLibrariesData: new Map()
        };
    }

    componentDidMount() {
        this.loadOrganisationInformation();
        this.loadOrganisationMediaLibrariesFromServer();
    }

    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation_name: response.data.organisation.name,
                    lockedGlobals: response.data.organisation.lockedGlobals
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    saveMediaLibrary(medialibrary, newName) {
        var self = this;
        axios
            .put(`${config.baseURL}/medialibraries/${medialibrary.uuid}`, {
                name: newName
            })
            .then(function(response) {
                self.loadOrganisationMediaLibrariesFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    deleteMediaLibrary(medialibrary) {
        var self = this;
        axios
            .delete(`${config.baseURL}/medialibraries/${medialibrary.uuid}`)
            .then(function(response) {
                self.loadOrganisationMediaLibrariesFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    lockMediaLibrary(medialibrary, enabled) {
        var self = this;
        axios
            .post(`${config.baseURL}/medialibraries/${medialibrary.uuid}/locked`, {
                locked: enabled
            })
            .then(function(response) {
                self.loadOrganisationMediaLibrariesFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    mediaLibraryRulesClicked(mediaLibrary) {
		const { uuid } = this.props.match.params;

		const parsed = qs.parse(this.props.location.search.substring(1));
		const rel = parsed.rel;

		let link = `/organisations/${uuid}/medialibraries/${mediaLibrary.uuid}/rules?rel=library`;

		this.props.history.push(link);
	}

    loadOrganisationMediaLibrariesFromServer() {
        var self = this;
        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}/medialibraries`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                self.setState({
                    medialibraries: response.data.mediaLibraries,
                    pageCount: response.data.pageCount,
                    totalMediaLibraries: response.data.itemCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url);

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadOrganisationMediaLibrariesFromServer();
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');
        }

        window.history.pushState(null, null, url);

        event.preventDefault();
        this.loadOrganisationMediaLibrariesFromServer();
    };

    handleSelectMediaLibrary = (mediaLibraryUuid, isSelected) => {
        let selectedMediaLibraries = new Set(this.state.selectedMediaLibraries);
        let selectedMediaLibrariesData = new Map(this.state.selectedMediaLibrariesData);
        let excludedMediaLibraries = new Set(this.state.excludedMediaLibraries);
        let excludedMediaLibrariesData = new Map(this.state.excludedMediaLibrariesData);

        if (isSelected) {
            if (this.state.selectAllMode) {
                excludedMediaLibraries.delete(mediaLibraryUuid);
                excludedMediaLibrariesData.delete(mediaLibraryUuid);
            } else {
                selectedMediaLibraries.add(mediaLibraryUuid);
                const mediaLibraryData = this.state.medialibraries.find(ml => ml.uuid === mediaLibraryUuid);
                if (mediaLibraryData) {
                    selectedMediaLibrariesData.set(mediaLibraryUuid, mediaLibraryData);
                }
            }
        } else {
            if (this.state.selectAllMode) {
                excludedMediaLibraries.add(mediaLibraryUuid);
                const mediaLibraryData = this.state.medialibraries.find(ml => ml.uuid === mediaLibraryUuid);
                if (mediaLibraryData) {
                    excludedMediaLibrariesData.set(mediaLibraryUuid, mediaLibraryData);
                }
            } else {
                selectedMediaLibraries.delete(mediaLibraryUuid);
                selectedMediaLibrariesData.delete(mediaLibraryUuid);
            }
        }

        this.setState({
            selectedMediaLibraries,
            selectedMediaLibrariesData,
            excludedMediaLibraries,
            excludedMediaLibrariesData
        });
    };

    handleSelectAll = (isSelectAll) => {
        if (isSelectAll) {
            this.setState({
                selectAllMode: true,
                selectedMediaLibraries: new Set(),
                selectedMediaLibrariesData: new Map(),
                excludedMediaLibraries: new Set(),
                excludedMediaLibrariesData: new Map()
            });
        } else {
            this.setState({
                selectAllMode: false,
                selectedMediaLibraries: new Set(),
                selectedMediaLibrariesData: new Map(),
                excludedMediaLibraries: new Set(),
                excludedMediaLibrariesData: new Map()
            });
        }
    };

    showBulkDeleteConfirmation = () => {
        const { t } = this.props;

        let bodyContent;

        if (this.state.selectAllMode) {
            const effectiveCount = this.state.totalMediaLibraries - this.state.excludedMediaLibraries.size;
            bodyContent = (
                <div>
                    <p><strong>Warning: This will delete {effectiveCount} media libraries!</strong></p>
                    <p>This includes all media libraries that match your current search {this.state.search ? ` for "${this.state.search}"` : ''}
                    {this.state.excludedMediaLibraries.size > 0 && <span>, excluding {this.state.excludedMediaLibraries.size} manually deselected items</span>}.</p>
                    <p><em>This action cannot be undone.</em></p>
                </div>
            );
        } else {
            const selectedItems = Array.from(this.state.selectedMediaLibrariesData.values());
            bodyContent = (
                <div>
                    <p><strong>This will delete {selectedItems.length} selected media libraries:</strong></p>
                    <ul style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                        {selectedItems.map(item => (
                            <li key={item.uuid}><strong>{item.name}</strong></li>
                        ))}
                    </ul>
                </div>
            );
        }

        this.dialog.show({
            title: t('Dialog.warning'),
            body: bodyContent,
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => this.dialog.hide(),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.confirmBulkDelete(),
                    'btn-danger'
                )
            ],
            bsSize: 'large'
        });
    };

    handleBulkDelete = () => {
        this.showBulkDeleteConfirmation();
    };

    confirmBulkDelete = () => {
        const { uuid } = this.props.match.params;

        const payload = {
            selectAll: this.state.selectAllMode,
            search: this.state.search,
            medialibraries: this.state.selectAllMode ? [] : Array.from(this.state.selectedMediaLibraries),
            excludedMediaLibraries: this.state.selectAllMode ? Array.from(this.state.excludedMediaLibraries) : []
        };

        const wasSelectAllWithSearch = this.state.selectAllMode && this.state.search;

        axios
            .post(`${config.baseURL}/organisations/${uuid}/medialibraries/bulk-delete`, payload)
            .then((response) => {
                const newState = {
                    selectedMediaLibraries: new Set(),
                    selectedMediaLibrariesData: new Map(),
                    excludedMediaLibraries: new Set(),
                    excludedMediaLibrariesData: new Map(),
                    selectAllMode: false
                };

                if (wasSelectAllWithSearch) {
                    newState.search = '';

                    const url = new URL(window.location.href);
                    url.searchParams.delete('search');
                    window.history.pushState(null, null, url);
                }

                this.setState(newState, () => {
                    this.loadOrganisationMediaLibrariesFromServer();
                });
            })
            .catch(function(error) {
                console.log(error);
                this.setState({
                    error: {
                        hidden: false,
                        title: `${this.props.t('Dialog.error')}:`,
                        style: 'danger',
                        message: (error.response && error.response.data && error.response.data.message) || 'Failed to delete media libraries'
                    }
                });
            }.bind(this));
    };

    handleCreateClicked() {
        const { t } = this.props;

        this.dialog.show({
            body: t('OrganisationMediaLibrariesTable.medialibrary_name'),
            prompt: Dialog.TextPrompt({
                placeholder: t('OrganisationMediaLibrariesTable.name'),
                initialValue: ''
            }),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('MediaSnippet.add_medialibrary'),
                    dialog => this.didClickAdd(dialog.value),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    didClickAdd(newName) {
        const { t } = this.props;
        const { uuid } = this.props.match.params;

        try {
            let self = this;
            axios
                .post(
                    `${config.baseURL}/organisations/${uuid}/medialibraries`,
                    {
                        name: newName,
                        global: true
                    }
                )

                .then(function(response) {
                    self.setState({
                        error: {
                            hidden: false,
                            title: `${t('CreateMediaLibrary.success')}:`,
                            style: 'success',
                            message: `${t(
                                'CreateMediaLibrary.created_message'
                            )}`
                        }
                    });

                    self.loadOrganisationMediaLibrariesFromServer();
                })
                .catch(function(err) {
                    self.setState({
                        error: {
                            hidden: false,
                            title: `${t('CreateMediaLibrary.error')}:`,
                            style: 'danger',
                            message: err.response.data.message || 'Unknown'
                        }
                    });
                });
        } catch (e) {
            this.setState({
                error: {
                    hidden: false,
                    title: `${t('CreateMediaLibrary.error')}:`,
                    style: 'danger',
                    message: `${t('CreateMediaLibrary.unknown_error')}`
                }
            });
        }
    }

    didConfirmLock(locked) {

        const { uuid } = this.props.match.params;

        var self = this;
        axios
            .post(`${config.baseURL}/organisations/${uuid}/lockedglobals`, {
                locked
            })
            .then(function(response) {
                self.loadOrganisationInformation();
                self.loadOrganisationMediaLibrariesFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }
    
    handleLockClicked() {
            const { t } = this.props;
    
            const locked = this.state.lockedGlobals;
            const body = locked ? t('Dialog.sure_unlock_global') : t('Dialog.sure_lock_global');
            const confirm = locked ? t('Dialog.unlock') : t('Dialog.lock');
    
            this.dialog.show({
                title: t('Dialog.warning'),
                body: body,
                actions: [
                    Dialog.Action(
                        t('Dialog.cancel'),
                        () => console.log('Cancel!'),
                        'btn-default'
                    ),
                    Dialog.Action(
                        confirm,
                        () => this.didConfirmLock(!locked),
                        'btn-danger'
                    )
                ],
                bsSize: 'large',
                onHide: dialog => {
                    dialog.hide();
                }
            });
        }

    handlePlayersClicked() {
        const { uuid } = this.props.match.params;

		let link = `/organisations/${uuid}/players/`;

		this.props.history.push(link);
    }
        
    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'OrganisationMediaLibraries.title'
        )}`;

        const selectedCount = this.state.selectAllMode
            ? this.state.totalMediaLibraries - this.state.excludedMediaLibraries.size
            : this.state.selectedMediaLibraries.size;
        const hasSelection = selectedCount > 0;

        const user = this.state.user;
        const { uuid } = this.props.match.params;

        const allowedAddRoles = this.state.lockedGlobals
                ? ['staff_super_admin', 'staff_admin']
                : ['staff_super_admin', 'staff_admin', 'organisation_admin', 'organisation_user'];

        return (
            <div className="OrganisationMediaLibraries">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('OrganisationMediaLibraries.title')}{' '}
                                    <small>
                                        {this.state.organisation_name}
                                    </small>
                                    
                                    {this.state.userIsAuthorized(user, allowedAddRoles) ? (
                                        <Button
                                            className="btn-primary header-button"
                                            onClick={() => this.handleCreateClicked()}
                                        >
                                            <em className="fa fa-plus fa-fw" /> {t('MediaSnippet.add_medialibrary')}
                                        </Button>
                                    ) : null}

                                    {this.state.userIsAuthorized(user, ['staff_super_admin']) ? (
                                        <Button
                                            className="btn-warning header-button"
                                            onClick={() => this.handleLockClicked()}
                                        >
                                            <em className={this.state.lockedGlobals ? 'fa fa-lock' : 'fa fa-unlock'}/> {this.state.lockedGlobals ? t('MediaSnippet.unlock_medialibraries') : t('MediaSnippet.lock_medialibraries')}

                                        </Button>
                                    ) : null}

                                    <Button
                                        className="btn-success header-button"
                                        onClick={() => this.handlePlayersClicked()}
                                    >
                                        <em className={'fa fa-tv'}/> { t('Organisation.viewplayers')}

                                    </Button>
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-tachometer-alt" />{' '}
                                        <Link to={`/organisations/${uuid}`}>
                                            {t('Dashboard.title')}
                                        </Link>
                                    </li>

                                    <li className="active">
                                        <i className="fa fa-images" />{' '}
                                        {t(
                                            'SideNavigation.globalmedialibraries'
                                        )}
                                    </li>
                                </ol>

                                <DismissableAlert
                                    title={this.state.error.title}
                                    message={this.state.error.message}
                                    hidden={this.state.error.hidden}
                                    style={this.state.error.style}
                                />
                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '15px' }}>
                                                    <form
                                                        role="search"
                                                        onSubmit={this.handleSubmit}
                                                        style={{ flex: hasSelection ? 1 : 1 }}
                                                    >
                                                        <FormGroup controlId="search" style={{ margin: 0 }}>
                                                            <InputGroup style={{ height: '38px' }}>
                                                                <FormControl
                                                                    type="text"
                                                                    value={this.state.search}
                                                                    onChange={this.handleChange}
                                                                    placeholder={t('Search')}
                                                                    style={{ height: '38px' }}
                                                                />
                                                                <InputGroup.Button>
                                                                    <Button
                                                                        onClick={this.handleSubmit}
                                                                        style={{ height: '38px' }}
                                                                    >
                                                                        <i className="glyphicon glyphicon-search" />
                                                                    </Button>
                                                                </InputGroup.Button>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </form>

                                                    {hasSelection && (
                                                        <div className="alert alert-info" style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            margin: 0,
                                                            padding: '8px 16px',
                                                            fontSize: '14px',
                                                            whiteSpace: 'nowrap',
                                                            flex: 2,
                                                            minWidth: '350px',
                                                            height: '38px',
                                                            borderRadius: '4px'
                                                        }}>
                                                            <span>
                                                                <strong>{selectedCount}</strong> media librar{selectedCount === 1 ? 'y' : 'ies'} selected
                                                                {this.state.selectAllMode && <span> (all pages)</span>}
                                                            </span>
                                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                                <Button
                                                                    className="btn-default btn-sm"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            selectedMediaLibraries: new Set(),
                                                                            selectedMediaLibrariesData: new Map(),
                                                                            excludedMediaLibraries: new Set(),
                                                                            excludedMediaLibrariesData: new Map(),
                                                                            selectAllMode: false
                                                                        });
                                                                    }}
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <em className='far fa-square' /> {t('MediaSnippetMediaLibrary.select_none')}
                                                                </Button>
                                                                <Button
                                                                    className="btn-danger btn-sm"
                                                                    onClick={this.handleBulkDelete}
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <em className="fa fa-trash" /> Delete Selected
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >
                                    <OrganisationMediaLibrariesTable
                                        userIsAuthorized={
                                            this.state.userIsAuthorized
                                        }
                                        user={this.state.user}
                                        medialibraries={
                                            this.state.medialibraries
                                        }
                                        lockedGlobals={this.state.lockedGlobals}
                                        uuid={uuid}
                                        onSave={this.saveMediaLibrary.bind(
                                            this
                                        )}
                                        onDelete={this.deleteMediaLibrary.bind(
                                            this
                                        )}
                                        onLockChanged={this.lockMediaLibrary.bind(
                                            this
                                        )}
                                        onRulesClicked={this.mediaLibraryRulesClicked.bind(this)}
                                        onSelectMediaLibrary={this.handleSelectMediaLibrary}
                                        onSelectAll={this.handleSelectAll}
                                        selectedMediaLibraries={this.state.selectedMediaLibraries}
                                        excludedMediaLibraries={this.state.excludedMediaLibraries}
                                        selectAllMode={this.state.selectAllMode}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(OrganisationMediaLibraries);
